import LeagueNameFrame from "../components/LeagueNameFrame";
import PrizeNavigation from "../components/PrizeNavigation";
import styles from "./LeagueNameSetup.module.css";

const LeagueNameSetup = () => {
  return (
    <div className={styles.leagueNameSetup}>
      <PrizeNavigation navigationButtonArea="/2813821-1@2x.png" />
      <div className={styles.content}>
        <p className={styles.leagueName}>Setup your league - step 1 of 2</p>
        <LeagueNameFrame />
      </div>
    </div>
  );
};

export default LeagueNameSetup;